/* eslint-disable react/prop-types */

/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { Button } from 'react-native-elements';
import {
  button,
  buttonMain,
  buttonPrimary,
  buttonOutlinePrimary,
  buttonDanger,
  buttonGrey,
  buttonDefault,
  buttonRounded,
  buttonText,
  buttonDisabled,
  buttonTextDisabled,
} from '@assets/styles/buttonStyles';
import { translate } from '@global/translate';
import { useTranslationDisabled } from '@components/shared/TranslationContext';
import PropTypes from 'prop-types';

const propTypes = {
  type: PropTypes.string,
  rounded: PropTypes.bool,
  buttonStyle: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]),
  titleStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabledStyle: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  disabledTitleStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  testID: PropTypes.string,
};

const defaultProps = {
  type: 'main',
  rounded: false,
  buttonStyle: {},
  titleStyle: '',
  disabledStyle: {},
  disabledTitleStyle: '',
  disabled: false,
  testID: 'button-default',
};

const ButtonDefault = (props) => {
  const {
    type = 'main',
    rounded = false,
    buttonStyle = {},
    titleStyle = '',
    disabledStyle = {},
    disabledTitleStyle = '',
  } = props;
  const translationDisabled = useTranslationDisabled();

  const buttonDisabledStyle = { ...button, ...buttonDisabled };
  const buttonTextDisabledStyle = { ...buttonText, ...buttonTextDisabled };
  const buttonType = type ? type : 'main';
  let buttonClass = buttonMain;
  let roundedStyle = {};
  if (buttonType == 'primary') {
    buttonClass = buttonPrimary;
  } else if (buttonType == 'outline-primary') {
    buttonClass = buttonOutlinePrimary;
  } else if (buttonType == 'danger') {
    buttonClass = buttonDanger;
  } else if (buttonType == 'default') {
    buttonClass = buttonDefault;
  } else if (buttonType == 'grey') {
    buttonClass = buttonGrey;
  }
  if (rounded) {
    roundedStyle = buttonRounded;
  }
  return (
    <Button
      {...props}
      title={translationDisabled ? props.title : translate(props.title)}
      disabled={!!props.disabled || false}
      buttonStyle={[button, buttonClass, roundedStyle, buttonStyle]}
      titleStyle={[buttonText, titleStyle]}
      disabledStyle={[buttonDisabledStyle, roundedStyle, disabledStyle]}
      disabledTitleStyle={[buttonTextDisabledStyle, disabledTitleStyle]}
    />
  );
};

ButtonDefault.propTypes = propTypes;
ButtonDefault.defaultProps = defaultProps;

export default React.memo(ButtonDefault, (prev, next) => prev == next);
